import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { FoodChallengeDetailsData } from '../../models/foodChallengeBlockData';

type Props = {
  enabled?: boolean;
  foodChallengeId: string;
  userId: string;
};

export const useFoodChallengeDetails = ({
  enabled = true,
  foodChallengeId,
  userId,
}: Props) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchFoodChallengeDetails = async (): Promise<FoodChallengeDetailsData> => {
    return await api({
      route: `/private/user/food-challenges/${foodChallengeId}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId,
      },
    });
  };

  const { data, isLoading, isError } = useQuery<FoodChallengeDetailsData, Error>({
    queryKey: ['food-challenge-details', userToken, userId, foodChallengeId],
    queryFn: fetchFoodChallengeDetails,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!foodChallengeId,
    refetchOnWindowFocus: false,
  });

  return {
    foodChallengeDetails: data ?? null,
    isLoading,
    isError,
  };
};
